import React, { forwardRef, useState, useImperativeHandle } from 'react'
import { Modal, Button, Tooltip, OverlayTrigger } from 'react-bootstrap'
import { Auth } from 'app';

export const ConfirmActionButton = ({ onConfirm, size, variant, label, modalTitle, modalBody, yesVariant, yesLabel, noVariant, noLabel }) => {
    const [showModal, setShowModal] = useState(false);

    const handleShow = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    const handleConfirm = () => {
        onConfirm();       // Call the action passed from parent
        handleClose();     // Close the modal after confirming
    };

    return (
        <>
            <Button size={size} variant={variant} onClick={handleShow}>{label}</Button>

            <Modal show={showModal} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{modalTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modalBody}</Modal.Body>
                <Modal.Footer>
                    <Button size="sm" variant={noVariant} onClick={handleClose}>
                        {noLabel}
                    </Button>
                    <Button size="sm" variant={yesVariant} onClick={handleConfirm}>
                        {yesLabel}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export const ResourceAccessButton = ({ course_name, resource, yesAction, yesLabel, yesVariant }) => {
    const { allowed, message } = Auth.useCheckResourceAccess(course_name, resource)
    if (allowed) {
        return <Button size="sm" variant={yesVariant ?? 'successs'} onClick={yesAction}>{yesLabel}</Button>
    } else {
        return <Button size="sm" variant="secondary-outline" disabled>{message}</Button>
    }
}

export const ActionCycleButton = forwardRef((props, ref) => {
    const [state, setState] = useState('SUCCESS')
    const runAction = async () => {
        if (state == 'LOADING') { // debounce
            return
        }
        setState('LOADING')
        try {
            const data = await props.action()
            setState('SUCCESS')
            return data
        } catch (err) {
            setState('ERROR')
            return null
        }
    }
    useImperativeHandle(ref, () => ({
        getState: () => {
            return state
        },
        setClean: () => {
            setState('CLEAN')
        },
        setDirty: () => {
            setState('DIRTY')
        },
        run: async () => {
            runAction()
        },
    }))
    const stateProps = {
        'CLEAN': { variant: 'outline-secondary', disabled: true },
        'DIRTY': { variant: 'outline-primary', disabled: false },
        'LOADING': { variant: 'outline-warning', disabled: true },
        'SUCCESS': { variant: 'outline-success', disabled: true },
        'ERROR': { variant: 'danger', disabled: false },
    }
    const renderTooltip = (innerProps) => (
        <Tooltip {...innerProps} style={{ ...innerProps.style, zIndex: 530 }}>{ props.tooltipMessage }</Tooltip>
    )
    return <>
        <OverlayTrigger placement='bottom' overlay={renderTooltip} trigger={['hover', 'focus']}>
            <span className="d-inline-block">
                <Button size="sm" variant={stateProps[state].variant} disabled={stateProps[state].disabled} onClick={runAction} style={{ pointerEvents: stateProps[state].disabled ? 'none' : 'auto', transition: "background-color 0.3s ease, border-color 0.3s ease" }} > {props.labels[state]}</Button>
            </span>
        </OverlayTrigger>
    </>
})